export const preventDefault = event => {
  if (event.cancelable) {
    event.preventDefault();
  }
};